<template>
  <div style="background-color: #F7F7F7;">
    <pcHeaders></pcHeaders>

    <div class="banner-box">
      <div style="width: 100%;">
        <el-carousel :interval="5000"
                   arrow="always"
                   height="400px">
        <el-carousel-item v-for="item in carouselList"
                          :key="item.id">
          <img :src="item.picUrl"
               style="position: relative;z-index: 999;width: 100%;height: 100%;"
               @click="toGetPicMessage(item)"
               alt="">
        </el-carousel-item>
      </el-carousel>
      </div>
    </div>

    <div style="display: flex;justify-content: space-between;width: 1200px;margin: 20px auto;background: #fff;height: 80px;align-items: center;padding-left: 20px;">
      
      <div style="display: flex;">
        <div>
        <div style="text-align: center;font-size: 16px;color: #333;">用户学员</div>
        <div style="text-align: center;font-size: 16px;color: #333;">报名学习流程</div>
      </div>

      <div style="margin-left: 47px;">
        <div style="text-align: center;"><img style="width: 32px;height: 32px;" src="../assets/indexImg/one@2x.png" alt=""></div>
        <div style="color: #0E2F52;font-size: 12px;">第一步：用户注册</div>
      </div>

      <div style="width: 50px;height: 1px;background: #0E2F52;opacity: 0.2;margin:0 8px;">
      </div>
      <div>
        <div style="text-align: center;"><img style="width: 32px;height: 32px;" src="../assets/indexImg/two@2x.png" alt=""></div>
        <div style="color: #0E2F52;font-size: 12px;">第二步：选课缴费</div>
      </div>

      <div style="width: 50px;height: 1px;background: #0E2F52;opacity: 0.2;margin:0 8px;">
      </div>
      <div>
        <div style="text-align: center;"><img style="width: 32px;height: 32px;" src="../assets/indexImg/three@2x.png" alt=""></div>
        <div style="color: #0E2F52;font-size: 12px;">第三步：网上学习</div>
      </div>

      <div style="width: 50px;height: 1px;background: #0E2F52;opacity: 0.2;margin:0 8px;">
      </div>
      <div>
        <div style="text-align: center;"><img style="width: 32px;height: 32px;" src="../assets/indexImg/four@2x.png" alt=""></div>
        <div style="color: #0E2F52;font-size: 12px;">第四步：完成学时</div>
      </div>

      <div style="width: 50px;height: 1px;background: #0E2F52;opacity: 0.2;margin:0 8px;">
      </div>
      <div>
        <div style="text-align: center;"><img style="width: 32px;height: 32px;" src="../assets/indexImg/five@2x.png" alt=""></div>
        <div style="color: #0E2F52;font-size: 12px;">第五步：打印证书</div>
      </div>
      </div>

      <div style="width: 248px;height: 80px;background: #0E2F52;color: #fff;font-size: 16px;padding-top: 19px;">
          <div style="text-align: center;">
            客服电话
          </div>
          <div style="text-align: center;">
            0562-2859269、2859619
          </div>
      </div>
    </div>

    <div class="banner" style="padding: 20px 0px 110px  0px;">
      <div class="banner-box1">
        <div class="banner-left">
            <div class="left-top" @click="goList('0700')" style="display: flex;justify-content: space-between;align-items: center; background: linear-gradient( 101deg, #E2404C 0%, #FF8686 100%);">
            <div>
              <div class="type" style="color: #FFFFFF;">公需课</div>
              <div class="type-info" style="color: #FFFFFF;"> 前沿科技、政策法规、国家战略。 </div>
            </div>

            <div class="type-btn" style="background: #FFFFFF;color: #E37444;">点击进入</div>
          </div>
          <div class="left-top" @click="goList('0702')" style="margin-top:20px;display: flex;justify-content: space-between;align-items: center;">
            <div>
               <div class="type">专业课</div>
               <div class="type-info">学习新理论、新技术、新方法,提高创新能力和专业技术水平。</div>
            </div>

            <div class="type-btn">点击进入</div>
          </div>
          <div class="left-top" @click="goList('0703')" style="display: flex;justify-content: space-between;align-items: center;margin-top: 20px;background: linear-gradient( 101deg, #4B7EB1 0%, rgba(80,129,179,0) 100%);">
           <div>
             <div class="type" style="color: #333333;">转岗培训</div>
             <div class="type-info" style="color: #333333;"> 掌握新岗位技术业务知识和技能，取得新岗位上岗资格所进行的培训。 </div>
           </div>

            <div class="type-btn" style="background: #0E3153;color: #fff;">点击进入</div>
          </div>
        </div>
        <div class="banner-right">
          <div class="type-list" style="justify-content: space-between;">
            <div style="display: flex;align-items: center;">
              <div class="list-item" :class="{ 'active': currentIndex == '0' }" @click="changeActive('0')">通知公告</div>
              <div class="list-item" :class="{ 'active': currentIndex == '1' }" @click="changeActive('1')">政策法规</div>
              <div class="list-item" :class="{ 'active': currentIndex == '2' }" @click="changeActive('2')">行业资讯</div>
            </div>
            <div style="color: #999999;font-size: 12px;cursor: pointer;" @click="more">
              了解更多
            </div>
          </div>
          <div class="info-list" v-if="currentIndex == '0'">
            <div class="list-item" v-for="(item, index) in tzggList" :key="index" @click="tzgg(item)">
              <div class="item-left">{{ item.TITLE }}</div>
              <div class="item-right">{{ item.PUBLISHTIME }}</div>
            </div>
            <div v-if="tzggList.length == 0" style="font-size: 16px;color: #535353;text-align: center;margin-top: 30px;">暂无数据~</div>
          </div>
          <div class="info-list" v-else-if="currentIndex == '1'">
            <div class="list-item" v-for="(item, index) in zcfgList" :key="index" @click="tzgg(item)">
              <div class="item-left">{{ item.TITLE }}</div>
              <div class="item-right">{{ item.PUBLISHTIME }}</div>
            </div>
            <div v-if="zcfgList.length == 0" style="font-size: 16px;color: #535353;text-align: center;margin-top: 30px;">暂无数据~</div>
          </div>
          <div class="info-list" v-else>
            <div class="list-item" v-for="(item, index) in hyzxList" :key="index" @click="tzgg(item)">
              <div class="item-left">{{ item.TITLE }}</div>
              <div class="item-right">{{ item.PUBLISHTIME }}</div>
            </div>
            <div v-if="hyzxList.length == 0" style="font-size: 16px;color: #535353;text-align: center;margin-top: 30px;">暂无数据~</div>
          </div>
        
        </div>
      </div>
    </div>
    


    <pcBottom></pcBottom>
    <Baywindow v-if="adPictureWindow !== '' "
               :adPictureWindow="adPictureWindow"
               :adPicture="adPicture" />

    <div v-if="adPicture !== ''&& !showTK"
         style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0, 0, 0, .7);z-index: 10000;">
      <div v-if="adPicture.jumpway == null"
           style="position: absolute;left: 50%;top: 50%;width: 500px;height: 585px;transform: translate(-50%,-50%);">
        <img style="width: 100%;height: 100%;"
             :src="adPicture.picUrl"
             alt="">
        <img @click="noShwo"
             style="position: absolute;top:-30px;right:-20px;cursor: pointer;width: 40px;z-index: 10001;"
             src="../assets/indexImg/closeIcon.png"
             alt="">
      </div>

      <div v-if="adPicture.jumpway !== null && adPicture.jumpway !== '02' "
           style="position: absolute;left: 50%;top: 50%;width: 500px;height: 585px;transform: translate(-50%,-50%);">
        <a 
        @click="goMessage(adPicture)"
           target="_blank"> <img style="width: 100%;height: 100%;"
               :src="adPicture.picUrl"
               alt=""></a>
        <img @click="noShwo"
             style="position: absolute;top:-30px;right:-20px;cursor: pointer;width: 40px;z-index: 10001;"
             src="../assets/indexImg/closeIcon.png"
             alt="">
      </div>

      <div v-if="adPicture.jumpway == '02'"
           style="position: absolute;left: 50%;top: 50%;width: 500px;height: 585px;transform: translate(-50%,-50%);">
        <a 
          :href="adPicture.picDesc"
           target="_blank"> <img style="width: 100%;height: 100%;"
               :src="adPicture.picUrl"
               alt=""></a>
        <img @click="noShwo"
             style="position: absolute;top:-30px;right:-20px;cursor: pointer;width: 40px;z-index: 10001;"
             src="../assets/indexImg/closeIcon.png"
             alt="">
      </div>

    </div>
    <flotRight />
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from './component/head.vue';
import pcBottom from './component/bottom.vue';
import { findIndexInfo, toHotClassByCode, exportEnrollData } from '../api/index';
import Baywindow from './component/Baywindow.vue';
import flotRight from '@/views/component/flotRight.vue';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    Baywindow,
    flotRight
  },
  data() {
    // 这里存放数据
    return {
      carouselList: [], //轮播图数据
      recommendList: [], //资源库课程列表
      skillClassList: {}, //技能提升分类
      activeIndex: null, //点击的样式
      classList: [], //热门的班级列表
      hyzxList: [], //行业资讯
      zcfgList: [], //政策法规
      tzggList: [], //通知公共
      codeList: [], //分类
      defaultImageUrl: require('../assets/images/noimg.png'),
      queryExl: {},
      adPictureWindow: '',
      adPicture: '',
      showTK: false,
      currentIndex: '0'
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    noShwo() {
      console.log(111);
      this.showTK = true;
    },
    handleError(event) {
      event.target.src = this.defaultImageUrl;
    },
    //浮动广告跳转
    goMessage(item) {
      console.log(item);
      this.$router.replace({
        path:'/message',
        query:{
          data:JSON.stringify(item)
        }
      })
    },
    toGetPicMessage(item) {
      console.log(item);
      if (item.jumpway == '02') {
        window.location.href = item.picDesc;
      } else {
        this.$router.push({
          path: '/zxDetil',
          query: {
            id: item.id
          }
        });
      }
    },
    //更多资讯
    more() {
      this.$router.push({
        path: 'tzgg'
      });
    },
    //通知公告点击
    tzgg(item) {
      console.log(item);
      this.$router.push({
        path: 'tzgg',
        query: {
          id: item.ID,
          current: this.currentIndex
        }
      });
    },
    //公需课
    goG() {
      this.$router.push('/gx');
    },
    goList(id, id2) {
      this.$router.push({
        path: '/lsitFs',
        query: {
          fCodeNo: id, //第一级
          codeNo: id2 //第二级
        }
      });
    },
    //课程资源库点击
    goresources(item) {
      console.log(item);
      this.$router.push({
        path: '/resources',
        query: {
          courseId: item.id
        }
      });
    },
    //技能提升点击
    oncode(item, index) {
      console.log(item);
      let query = {
        codeId: item.id,
        isSills: true,
        isChSkills: false,
        num: 6
      };
      //热门课程班级
      toHotClassByCode(query).then(res => {
        this.skillClassList = res.data.data.classList;
      });
      this.activeIndex = index;
    },
    getList() {
      // 首页数据
      findIndexInfo().then(res => {
        console.log(res.data.data);
        if (res.data.data == '01') {
          window.location.href = 'https://jxjy-m.tljspx.com/';
          return false;
        }
        this.carouselList = res.data.data.picList;
        this.classList = res.data.data.hotCourseList;
        this.codeList = res.data.data.skillschSysCodeList;
        this.recommendList = res.data.data.recommendCourseList;
        this.hyzxList = res.data.data.hyzxList;
        this.zcfgList = res.data.data.zcfgList;
        this.tzggList = res.data.data.tzggList;
        this.skillClassList = res.data.data.skillClassList.classList;
        this.adPictureWindow = res.data.data.adPictureWindow;
        this.adPicture = res.data.data.adPicture;
      });
      // this.$store.state.m_user.dispatch('updateValue', 1);
    },
    //试听
    goShit(item) {
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: item.id
        }
      });
    },
    goPay(item) {
      this.$router.push({
        path: '/classDetail',
        query: {
          classId: item.id
        }
      });
    },
    changeActive(index) {
      this.currentIndex = index;
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    console.log(isMobile);
    if (isMobile) {
      window.location.href = 'https://jxjy-m.tljspx.com/';
    }
    this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less">
/* //@import url(); 引入公共css类 */
.banner-box {
  width: 100%;
  background: linear-gradient( 180deg, #025BA9 0%, #FFFFFF 100%);
  display: flex;
  justify-content: center;
}

.pos {
  height: 400px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 998;
  font-family: Regular;
  .newsBox {
    position: absolute;
    width: 220px;
    right: -600px;
    top: 50px;
    z-index: 200;
    height: 300px;
    background: #fff;
    padding: 12px 0 0 0;
    z-index: 999;
    .newList {
      margin-top: 16px;
      padding: 0px 10px 0 16px;
      cursor: pointer;
      .listText {
        font-size: 14px;
        font-weight: 400;
        color: #999;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0;
        margin-left: 5px;
      }
    }
    .botmBtn {
      position: absolute;
      bottom: 0;
      left: 0;
      text-align: center;
      height: 65px;
      line-height: 65px;
      background: #0E2F52;
      color: #fff;
      width: 100%;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.flex {
  display: flex;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.banner {
  font-family: Regular;
  display: flex;
  justify-content: center;
  .fastTrack {
    width: 1200px;
    padding: 20px 0px;
    display: flex;
    justify-content: space-between;
    font-family: bold;
    .text {
      font-size: 22px;
      color: #333333;
      display: flex;
      align-items: center;
      img {
        width: 30px;
        height: 16px;
        margin: 0 15px;
      }
      span {
        color: #0E2F52;
      }
    }
    .more {
      width: 72px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      color: #127AE6;
      border-radius: 18px;
      border: 1px solid #127AE6;
      cursor: pointer;
    }
  }
  .fastList {
    display: flex;
    margin-top: 37px;

    .box1 {
      width: 285px;
      height: 160px;
      position: relative;
      margin-right: 20px;
      color: #fff;
      cursor: pointer;
      .textBox {
        padding: 33px 0 0 20px;
        font-size: 24px;
        font-family: bold;
        .bc {
          width: 50px;
          height: 4px;
          margin-top: 10px;
          background: #fff;
        }
        .section-content {
          margin-top: 10px;
          width: 170px;
          font-size: 12px;
          font-family: Regular;
          font-weight: 500;
          line-height: 20px;
          color: #ffffff;
          opacity: 0.8;
        }
      }
      img {
        z-index: -1;
      }
    }
  }
  .crl {
    display: flex;
    margin-top: 50px;
    padding-bottom: 70px;
    .section-right {
      display: flex;
      width: 770px;
      height: 400px;
      flex-wrap: wrap;
      margin-left: 10px;
      .slistBox {
        width: 180px;
        height: 190px;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.09);
        margin-right: 15px;
        cursor: pointer;
        .boxImg {
          width: 100%;
          height: 149px;
        }
        .textBox {
          height: 40px;
          line-height: 40px;
          text-align: center;
        }
      }
      .slistBox:nth-child(4n) {
        margin-right: 0 !important;
      }
      .slistBox:nth-child(n + 5):nth-child(-n + 8) {
        margin-top: 12px;
      }
    }
  }
  .reList {
    display: flex;
    flex-wrap: wrap;
    .reBox {
      width: 210px;
      height: 265px;
      margin-right: 37px;
      box-shadow: 0px 2px 10px #dddddd;
      border-radius: 6px;
      margin-bottom: 20px;
      cursor: pointer;
      img {
        width: 100%;
        height: 170px;
      }
      .reText {
        padding: 9px 10px 0;
        .text {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 16px;
          color: rgba(51, 51, 51, 1);
        }
        .xue {
          font-size: 12px;
          color: #bbbbbb;
          font-family: Regular;
          margin: 5px 0px;
        }
        .botom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .price {
            font-size: 14px;
            font-weight: bold;
            color: #F21717;
            font-family: Regular;
          }
          .botmBtn {
            width: 78px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            background: #127AE6;
            font-size: 14px;
            color: #fff;
            font-family: Regular;
          }
        }
      }
    }
    .reBox:nth-child(5n) {
      margin-right: 0 !important;
    }
    .reBox:hover {
      opacity: 0.7;
    }
  }
  .banner-box1 {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    .banner-left {
      width: 390px;
      .left-top {
        position: relative;
        width: 380px;
        height: 100px;
        padding:0 20px 0px 30px;
        background: linear-gradient( 101deg, #0E2F52 0%, #4B7EB1 100%);
        cursor: pointer;
        .type {
          font-size: 18px;
          font-weight: bold;
          color: #FFFFFF;
          margin-bottom: 4px;
        }
        .type-info {
          width: 230px;
          font-size: 14px;
          color: #FFFFFF;
        }
        .type-btn {
          width: 86px;
          height: 30px;
          background: #FFFFFF;
          border-radius: 15px 15px 15px 15px;
          text-align: center;
          line-height: 30px;
          color: #133559;
          font-size: 14px;
          margin-top: 8px;
        }
      }
      .left-bottom {
        width: 390px;
        height: 150px;
        padding: 30px 100px 30px 30px;
        background: url("~@/assets/images/zgpx.png") no-repeat;
        background-size: cover;
        cursor: pointer;
        .type {
          font-size: 20px;
          font-weight: bold;
          color: #FFFFFF;
          margin-bottom: 10px;
        }
        .type-info {
          font-size: 14px;
          color: #FFFFFF;
        }
      }
    }
    .banner-right {
      width: 790px;
      display: flex;
      flex-direction: column;
      .type-list {
        display: flex;
        align-items: center;
        .list-item {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          margin-right: 10px;
          cursor: pointer;
        }
        .active {
          font-size: 20px;
          font-weight: bold;
          color: #0E2F52;
        }
      }
      .info-list {
        flex: 1;
        padding-top: 10px;
        .list-item {
          margin-bottom: 18px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          .item-left {
            width: 600px;
            font-size: 16px;
            color: #535353;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .item-right {
            font-size: 14px;
            color: #999999;
          }
          :hover {
            color: #025ba9;
          }
        }
      }
      .more-btn {
        display: flex;
        justify-content: center;
        .btn {
          width: 100px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          font-size: 12px;
          color: #127AE6;
          border-radius: 16px;
          border: 1px solid #E2E2E2;
          cursor: pointer;
        }
      }
    }
  }
}
.skillBox {
  width: 100%;
  background: #f7f7f7;
  padding: 60px 0 72px 0;

  .fastTrack {
    width: 1200px;
    display: flex;
    justify-content: center;
    font-family: bold;
    .text {
      font-size: 32px;
      display: flex;
      align-items: center;
      img {
        width: 30px;
        height: 16px;
        margin: 0 15px;
      }
      span {
        color: #0E2F52;
      }
    }
  }
  .skBn {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    padding-bottom: 20px;
    .skLeft {
      width: 245px;
      height: 618px;
      position: relative;
      padding: 32px 10px 0 20px;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
      .leftTitle {
        font-family: Medium;
        position: relative;
        font-size: 28px;
        color: #0E2F52;
        margin-bottom: 32px;
        font-family: bold;
        z-index: 2;
      }
      .skList {
        font-family: Medium;
        position: relative;
        z-index: 2;
        height: 30px;
        line-height: 30px;
        padding: 0 17px;
        border: 1px solid #0E2F52;
        border-radius: 15px;
        color: #0E2F52;
        font-size: 14px;
        cursor: pointer;
        margin: 0 10px 15px 0;
        max-width: 220px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .active {
        font-family: Medium;
        position: relative;
        z-index: 2;
        background: #0E2F52 !important;
        color: #fff !important;
      }
      .skList:hover {
        font-family: Medium;
        position: relative;
        z-index: 2;
        background: #0E2F52 !important;
        color: #fff !important;
      }
    }
    .skCenter {
      padding-left: 20px;
      font-family: Regular;
      background: #fff;
      .centerList {
        margin-top: 17px;
        width: 670px;
        display: flex;
        flex-wrap: wrap;
        .listBox {
          width: 210px;
          height: 224px;
          margin-right: 20px;
          cursor: pointer;
          img {
            width: 100%;
            height: 174px;
          }
          .textBox {
            font-size: 16px;
            color: #333;
            margin: 13px 0;
          }
        }
        .listBox:nth-child(3n) {
          margin-right: 0 !important;
        }
        .listBox:hover {
          opacity: 0.7;
        }
      }
    }
    .skRight {
      background: #fff;
      width: 245px;
      padding: 20px 20px 0 20px;
      .fagui {
        .fTitle {
          display: flex;
          img {
            width: 15px;
            height: 24px;
          }
          .tips {
            font-family: Regular;
            font-size: 22px;
            margin-left: 10px;
          }
          .more {
            margin-left: 50px;
            color: #ccc;
            padding-top: 7px;
            cursor: pointer;
          }
        }
        .cotent {
          p {
            font-size: 14px;
            color: #999;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
          }
          p:hover {
            opacity: 0.7 !important;
          }
        }
      }
    }
  }
}
</style>